import React from "react"
import { Popup } from "react-map-gl/mapbox"
import PopupOpen from "./popupOpen.tsx"
/*
import PopupPlanned from "./popupPlanned"
import PopupConstruction from "./popupContruction"
*/

import type { StationFeature } from "types/stations"

interface PopupProps {
    chosenStation: StationFeature | undefined
}

const mapPopup: React.FC<PopupProps> = ({ chosenStation }) => {
    if (!chosenStation) {
        return null
    }
    const popupComponent = <PopupOpen chosenStation={chosenStation} />

    return (
        <Popup
            key={chosenStation.id}
            // className="w-[800px] h-32"
            longitude={chosenStation?.geometry.coordinates[0]}
            latitude={chosenStation?.geometry.coordinates[1]}
            closeButton={false}
            anchor={"bottom"}
            offset={30}
        >
            {popupComponent}
        </Popup>
    )
}

export default mapPopup
